export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <div className="div-footermenu">
      <div className="Table" style={{ margin: "0px auto" }}>
        <div className="Row">
          <div className="Cell">
            <h5>
              Copyrights &copy; {currentYear} Maratha Hitawardhak Mandal
              Dombivli. All Rights Reserved
            </h5>
          </div>
        </div>
      </div>
    </div>
  );
}
